import React from 'react';

type IntegrationEventProps =
  | {
      type: 'created';
      isActive: boolean;
    }
  | {
      type: 'updated';
      isActive: boolean;
    }
  | {
      type: 'deleted';
      label: string;
    };

export function IntegrationEvent(props: IntegrationEventProps) {
  if (props.type === 'deleted') {
    return <>{props.label}</>;
  }

  return (
    <span className="text-xs">
      <span className="mr-[6px] font-semibold">Is active:</span>
      {props.isActive ? 'Yes' : 'No'}
    </span>
  );
}
